import CreditsPaymentDetailsTable from './CreditsPaymentDetailsTable';

export default CreditsPaymentDetailsTable;
